import {
    Grid,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Typography,
    TableBody,
  } from "@material-ui/core";
  import React, { FunctionComponent } from "react";
  import { financialItemStyles } from "./financialItemStyle";
  import TableContainer from "@material-ui/core/TableContainer";
  type VoucherDataProps = {
    voucherData: Array<object>;
    voucherTotalAmount: number;
  };
  
  export const VoucherSummary: FunctionComponent<
  VoucherDataProps
  > = (voucherData: { [key: string]: any }) => {
    const classes = financialItemStyles();
    return (
        <Grid container>
      <Grid item xs={12}>
        <TableContainer>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead className={classes.tableRow} style={{ height: "4em" }}>
              <TableRow style={{ height: "3em" }}>
                <TableCell
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  style={{ width: "35%" }}
                >
                   Name
                </TableCell>
                <TableCell className={classes.deptHead} align="center">
                   Count
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                   Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {voucherData &&
                voucherData.voucherData.map((data: any) => (
                  <TableRow>
                    <TableCell align="left" className={classes.columnWeight}>
                      {data.v_name}
                    </TableCell>
                    <TableCell align="center" className={classes.tableContent}>
                      {data.v_count}
                    </TableCell>
                    <TableCell align="right" className={classes.columnWeight}>
                      {data.v_amount}
                    </TableCell>
                  </TableRow>
                 ))}
               
                <TableRow style={{ height: "3em" }}>
                <TableCell align="left" className={classes.totalCellStyle}>
                  <Typography className={classes.total}>Total</Typography>
                </TableCell>
                <TableCell align="left" className={classes.middleTotalcell} />
                <TableCell align="right" className={classes.totalValueCell}>
                  <Typography className={classes.value}>
                    {voucherData.voucherTotalAmount}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
    );
  };
  